/**
 * Formats an instant as UTC RFC 3339 with **second** precision and a literal `Z`
 * suffix (`YYYY-MM-DDTHH:mm:ssZ`).
 *
 * `Date.prototype.toISOString()` always emits milliseconds
 * (`…ss.sssZ`). Callers that mirror MySQL `DATE_FORMAT(…, '%Y-%m-%dT%H:%i:%sZ')`
 * or metering-provider timestamps need the second-precision form so wire
 * payloads stay identical end-to-end.
 *
 * @param value - Instant to format. `null` / `undefined` pass through as `null`
 *   so optional columns stay optional without callers branching.
 * @returns Second-precision RFC 3339 UTC string, or `null` when `value` is nullish.
 *
 * @example
 * toRfc3339Z(new Date('2026-01-01T12:34:56.789Z')); // '2026-01-01T12:34:56Z'
 * toRfc3339Z(null); // null
 */
export function toRfc3339Z(value: Date | null | undefined): string | null {
  if (!value) {
    return null;
  }

  return value.toISOString().replace(/\.\d{3}Z$/, 'Z');
}
